/*
 * @Description:
 * @LastEditors: Please set LastEditors
 * @Date: 2020-11-10 13:57:25
 */
/*
 * @Description: 项目人员
 * @Date: 2020-10-14 15:58:13
 * @LastEditors: wjx
 */
import { activity, activityPerson, taxPayment } from '@/api/ajax';
import fields from './fields';
import search from './search';
import TableRenderClass from '@C/tableRender/tableRenderClass';
import createExtend from '@C/createExtend';
import activePersonAdd from '../../active-person-add';
import addUsers from '@/page/project-personnel-inside/list/child/add-users';

import qs from 'qs';

// 导出
const donwload = async ({ tableRender }) => {
  const searchQuery = tableRender.searchQuery;
  tableRender.$downloadFile(
    `${activity.exportList}?${qs.stringify({
      ...searchQuery,
      sersviceActivityId: searchQuery.serviceActivityId
    })}`,
    true
  );
};
// 导入用户
const personsAdd = async ({ h, vm, tableRender }) => {
  await taxPayment.checkExportPersonnel({
    projectId: vm.$route.query.id
  });
  const dialog = vm.$xrkDialog;
  const searchQuery = tableRender.searchQuery;
  dialog.call(vm.$parent, {
    showConfirm: false,
    showCancel: false,
    $slots: {
      default: h(addUsers, {
        props: {
          downloadUrl: activity.downloadPersonTemplate,
          importData: activity.uploadPersons,
          query: { serviceActivityId: searchQuery.serviceActivityId }
        }
      })
    }
  });
};
let example = new TableRenderClass({ fields, search });

let part = example.createPart({
  name: '项目人员',
  list: activityPerson.list,
  requestNow: true,
  search: ['fullName', 'phone', 'settlementStatus'],
  fields: [
    'index',
    'fullName',
    'phone',
    'status',
    'entryStatus',
    'taskPrice',
    'settlementStatus',
    'handler'
  ],
  moreBtnArr: [
    {
      name: '下载导出',
      // type: 'primary',
      render(h, ctx) {
        const indexPage = ctx.injections.indexPage;
        const tableRender = indexPage.$refs.tableRender;
        return (
          <el-button
            style="height:40px"
            type="primary"
            disabled={!tableRender.tableData.length}
            onClick={donwload.bind(null, { tableRender })}
          >
            下载导出
          </el-button>
        );
      }
    },
    {
      name: '导入',
      render(h, ctx) {
        const indexPage = ctx.injections.indexPage;
        const tableRender = indexPage.$refs.tableRender;
        return (
          <el-button
            style="height:40px"
            type="primary"
            onClick={personsAdd.bind(null, { h, vm: ctx.parent, tableRender })}
          >
            导入
          </el-button>
        );
      }
    },
    {
      name: '单独添加',
      type: 'primary',
      async fn(app, table) {
        await taxPayment.checkExportPersonnel({
          projectId: app.$route.query.id
        });
        const c = createExtend(activePersonAdd, {
          serviceActivityId: table.searchQuery.serviceActivityId
        });
        // 确认添加后重载
        c['$on']('confirm', () => {
          table.init();
        });
      }
    }
  ]
});

export default [{ name: '项目人员', childMenu: [part] }];
